export { SplashScreen } from "./SplashScreen";
